import BaseModal from "../../../../Components/Modals/BaseModal";
import "../../../../Components/Modals/Style/modalStyles.scss";
import Approve from "../../../../Images/86372-addland-thanks-you.gif";

export default function ApproveModal({
  isOpen,
  handleClose,
  handleDelete,
  headText,
  infoText,
  isLoading,
  extra = null,
  hasComment = false,
  comment,
  disabled = false,
  btnText,
}) {
  return (
    <BaseModal isOpen={isOpen} handleClose={handleClose}>
      <div className="delete-setup">
        <div className="flex justify-center">
          <img src={Approve} alt="" className="w-[200px] h-[200px]" />
        </div>
        <div className="modal__text">
          <div className="modal__text--head">{headText ?? "Approve"}</div>
          <div className="modal__text--main">
            {infoText ?? "Are you sure you want to approve this process?"}
          </div>
        </div>
        {extra && <div className="px-7 py-3">{extra}</div>}
        {hasComment && <div>{comment}</div>}
        <div className="modal__actions">
          <button className="btn btn-outline" onClick={handleClose}>
            Cancel
          </button>
          <button
            disabled={isLoading || disabled}
            className="btn btn-success"
            onClick={handleDelete}
          >
            {isLoading ? "Approving..." : btnText ?? "Approve"}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
